import { render, staticRenderFns } from "./CustomerAutoComplete.vue?vue&type=template&id=20d97d5e&scoped=true&"
import script from "./CustomerAutoComplete.vue?vue&type=script&lang=js&"
export * from "./CustomerAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d97d5e",
  null
  
)

export default component.exports